import { IQuotation } from '../../interfaces/quotation.interface';

export class LoadQuotation {
  static type = '[Quotation] Load Quotation';

  constructor(
    public id: string,
    public isCacheEnabled: boolean = true,
  ) {}
}

export class ClearQuotation {
  static type = '[Quotation] Clear Quotation';
}

export class UpdateCurrentQuotation {
  static type = '[Quotation] Update Current Quotation';

  constructor(public quotation: IQuotation) {}
}

export class MarkAsFavorite {
  static type = '[Quotation] Mark As Favorite';

  constructor(public quotationId: string) {}
}

export class SmartBanner {
  static type = '[Quotation] Smart Banner';

  constructor(public quotationId: string) {}
}
